{
  "use_initiate_billing_plan_flow": {
    "errors": {
      "initiation_failed_title": "Failed to start billing flow",
      "initiation_failed_description": "Something went wrong preparing your plan. Please try again or contact support.",
      "redirect_failed_title": "Failed to start billing flow",
      "redirect_failed_description": "We couldn't redirect you to complete plan selection. Please try again or contact support."
    }
  }
}
